(function () {
  'use strict';

  // Meerdere hero-instanties op één pagina moeten onafhankelijk werken. Alles
  // hieronder is daarom gescoped op de eigen section-root: selectors, observer,
  // events en de animatielus. Elke instantie houdt haar eigen opruimlijst bij,
  // zodat de Theme Editor een sectie kan vervangen zonder losse listeners of
  // een doorlopende requestAnimationFrame-lus achter te laten.
  var FLAG = 'nxHeroInit';

  function roots(scope) {
    var node = scope || document;
    var found = [];
    if (node.nodeType === 1 && node.matches && node.matches('[data-nx-hero]')) found.push(node);
    Array.prototype.push.apply(found, node.querySelectorAll('[data-nx-hero]'));
    return found;
  }

  function init(root) {
    if (root.dataset[FLAG]) return;
    root.dataset[FLAG] = '1';

    var cleanup = [];
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ------------------------------------------------------------------
       Scroll reveal (fade + rise) via IntersectionObserver
       ------------------------------------------------------------------ */
    var revealEls = root.querySelectorAll('.reveal');
    if ('IntersectionObserver' in window && revealEls.length) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
      );
      Array.prototype.forEach.call(revealEls, function (el) { io.observe(el); });
      cleanup.push(function () { io.disconnect(); });
    } else {
      Array.prototype.forEach.call(revealEls, function (el) { el.classList.add('is-visible'); });
    }

    /* ------------------------------------------------------------------
       Nav: achtergrond na scrollen + mobiele burger
       ------------------------------------------------------------------ */
    var nav = root.querySelector('[data-nx-nav]');
    var burger = root.querySelector('[data-nx-burger]');

    function onScrollNav() {
      if (!nav) return;
      if (window.scrollY > 12) nav.classList.add('is-scrolled');
      else nav.classList.remove('is-scrolled');
    }
    onScrollNav();
    window.addEventListener('scroll', onScrollNav, { passive: true });
    cleanup.push(function () { window.removeEventListener('scroll', onScrollNav); });

    if (burger && nav) {
      var toggleNav = function () { nav.classList.toggle('is-open'); };
      burger.addEventListener('click', toggleNav);
      cleanup.push(function () { burger.removeEventListener('click', toggleNav); });

      Array.prototype.forEach.call(nav.querySelectorAll('.nx-nav__link'), function (link) {
        var closeNav = function () { nav.classList.remove('is-open'); };
        link.addEventListener('click', closeNav);
        cleanup.push(function () { link.removeEventListener('click', closeNav); });
      });
    }

    /* ------------------------------------------------------------------
       Parallax + 3D-tilt op de vos
       ------------------------------------------------------------------ */
    var visualWrap = root.querySelector('[data-nx-visual]');
    var tiltEl = root.querySelector('[data-nx-tilt]');
    var parallaxEls = root.querySelectorAll('[data-nx-parallax]');

    var pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var mouseX = 0, mouseY = 0, targetRotX = 0, targetRotY = 0, currentRotX = 0, currentRotY = 0;
    var scrollRotY = 0;
    var rafId = null;

    function updateScrollEffects() {
      if (reduceMotion) return;

      var rect = root.getBoundingClientRect();
      var progress = 1 - Math.min(Math.max((rect.top + rect.height * 0.3) / window.innerHeight, 0), 1);

      Array.prototype.forEach.call(parallaxEls, function (el) {
        var speed = parseFloat(el.getAttribute('data-nx-parallax')) || 0.15;
        el.style.transform = 'translateY(' + (progress * -80 * speed * 5) + 'px)';
      });

      if (visualWrap) {
        var vRect = visualWrap.getBoundingClientRect();
        var vProgress = Math.min(Math.max((window.innerHeight - vRect.top) / (window.innerHeight + vRect.height), 0), 1);
        scrollRotY = (vProgress - 0.5) * 10;
      }
    }

    function animateTilt() {
      // Sectie vervangen of verwijderd: lus netjes beëindigen.
      if (!root.isConnected) return;
      if (!reduceMotion && tiltEl) {
        currentRotX += (targetRotX - currentRotX) * 0.08;
        currentRotY += (targetRotY + scrollRotY - currentRotY) * 0.08;
        tiltEl.style.transform = 'rotateX(' + currentRotX + 'deg) rotateY(' + currentRotY + 'deg)';
      }
      rafId = requestAnimationFrame(animateTilt);
    }

    if (pointerFine && tiltEl && !reduceMotion) {
      var onMove = function (e) {
        var rect = root.getBoundingClientRect();
        mouseX = (e.clientX - rect.left) / rect.width - 0.5;
        mouseY = (e.clientY - rect.top) / rect.height - 0.5;
        targetRotY = mouseX * 10;
        targetRotX = mouseY * -8;
      };
      var onLeave = function () { targetRotX = 0; targetRotY = 0; };
      root.addEventListener('mousemove', onMove);
      root.addEventListener('mouseleave', onLeave);
      cleanup.push(function () {
        root.removeEventListener('mousemove', onMove);
        root.removeEventListener('mouseleave', onLeave);
      });
    }

    if (!reduceMotion) {
      window.addEventListener('scroll', updateScrollEffects, { passive: true });
      window.addEventListener('resize', updateScrollEffects);
      cleanup.push(function () {
        window.removeEventListener('scroll', updateScrollEffects);
        window.removeEventListener('resize', updateScrollEffects);
      });
      updateScrollEffects();
      rafId = requestAnimationFrame(animateTilt);
      cleanup.push(function () { if (rafId) cancelAnimationFrame(rafId); });
    }

    root._nxHeroCleanup = cleanup;
  }

  function destroy(root) {
    if (root._nxHeroCleanup) {
      root._nxHeroCleanup.forEach(function (fn) { fn(); });
      root._nxHeroCleanup = null;
    }
    delete root.dataset[FLAG];
  }

  function initAll(scope) { roots(scope).forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // De Theme Editor vervangt secties zonder de pagina te herladen. Alleen
  // reageren op events met een echt element als target: een event dat op het
  // document zelf gericht is, zou anders elke instantie tegelijk opruimen.
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || e.target.nodeType !== 1) return;
    initAll(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || e.target.nodeType !== 1) return;
    roots(e.target).forEach(destroy);
  });
})();
